import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  BusinessBySellerVo,
  EntityBySellerVo,
  OfferManagerSelectVo,
  OrderReviewAppVo,
  StoreUrlVo,
  PublicStoreVo,
  SellerBusinessVo
} from './types';

/**
 * 店铺url 换 店铺id
 */

export const getStoreSellerId = (query: { storeUrl: string }): AxiosPromise<StoreUrlVo> => {
  return request({
    url: '/member/store/storeUrlExchange',
    method: 'get',
    params: query
  });
};
/**
 * 店铺公开页seller信息
 */
export const getSellerInfo = (query: { sellerId?: string }): AxiosPromise<PublicStoreVo> => {
  return request({
    url: '/member/store/publicStore',
    method: 'get',
    params: query
  });
};

/**
 * 当前卖家所有offer所涵盖的业务类型
 */

export const getBussinessCategory = (query: { sellerId?: number }): AxiosPromise<BusinessBySellerVo> => {
  return request({
    url: '/product/urlMapping/game-service/getBusinessByOffer',
    method: 'get',
    params: query
  });
};
/**
 * 当前卖家所有offer所涵盖的游戏/品牌
 */

export const getAllGames = (query: { sellerId?: number }): AxiosPromise<EntityBySellerVo> => {
  return request({
    url: '/product/urlMapping/game-service/getEntityByOffer',
    method: 'get',
    params: query
  });
};

/**
 * offer列表页查询包含（game-service offer + 数字商品offer）
 */

export const getQueryPageList = (query: {
  businessId?: number | string;
  offerName?: string;
  entityId?: number | string;
  pageSize?: number;
  pageNum?: number;
  sellerId?: number;
  onSale?: number; // 0:下架 1:上架
}): AxiosPromise<OfferManagerSelectVo> => {
  return request({
    url: '/product/urlMapping/game-service/queryPageList',
    method: 'get',
    params: query
  });
};

/**
 * 分页查询店铺评价
 */
export const getStoreRatings = (query: {
  pageNum?: number;
  pageSize?: number;
  sellerId?: number;
  storeId?: number;
  score?: number | string;
}): AxiosPromise<OrderReviewAppVo> => {
  return request({
    url: '/api/order/review/store/page',
    method: 'get',
    params: query
  });
};

/**
 * 卖家业务查询
  GET /member/seller/businessPermission
  接口ID：266479225
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-266479225
 */

export const getSellerBusinessList = (): AxiosPromise<SellerBusinessVo> => {
  return request({
    url: '/member/seller/businessPermission',
    method: 'get'
  });
};
